import { render, staticRenderFns } from "./pip-closing.vue?vue&type=template&id=51a8043a&"
import script from "./pip-closing.vue?vue&type=script&lang=js&"
export * from "./pip-closing.vue?vue&type=script&lang=js&"
import style0 from "./pip-closing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pip-closing.vue"
export default component.exports